module.exports = __webpack_public_path__ + "img/mirka-accounting1.ca90d68e.png";